(function () {
  var ACCORDION_SELECTOR = 'accordeon-component.product-content-tab--collapsible-row';
  var BUTTON_SELECTOR = ACCORDION_SELECTOR + ' accordeon-button';

  function collapseAccordion(acc) {
    if (acc.getAttribute('data-aria-expanded') !== 'true') return;

    if (typeof acc.hide === 'function') {
      acc.hide();
      return;
    }

    acc.setAttribute('data-aria-expanded', 'false');
    var wrap = acc.querySelector('[data-accordeon-content-wrap]');
    if (wrap) wrap.style.maxHeight = '0px';
  }

  function closeOtherAccordions(opened, root) {
    root.querySelectorAll(ACCORDION_SELECTOR).forEach(function (acc) {
      if (acc !== opened) collapseAccordion(acc);
    });
  }

  function afterAccordionToggle(button, root) {
    var opened = button.closest(ACCORDION_SELECTOR);
    if (!opened) return;

    window.setTimeout(function () {
      if (opened.getAttribute('data-aria-expanded') !== 'true') return;
      closeOtherAccordions(opened, root);
    }, 0);
  }

  function isEnterKey(event) {
    return event.key === 'Enter' || event.keyCode === 13;
  }

  function init() {
    var info = document.querySelector('.product__info');
    if (!info) return;

    info.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest(BUTTON_SELECTOR);
      if (!button) return;
      afterAccordionToggle(button, info);
    });

    info.addEventListener('keydown', function (event) {
      if (!isEnterKey(event)) return;
      var button = event.target.closest && event.target.closest(BUTTON_SELECTOR);
      if (!button) return;
      afterAccordionToggle(button, info);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
